/**
 * en-GB messages added by shared reception task M-SR (docs/SHARED-RECEPTION-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts. UK English only.
 * The Companion building marshal screens (docs/modules/shared-reception.md s14). Keys `sr.phone.title`, `offlineList`,
 * `noCurrentList` and `notShared` are the architect's (sr-arch.ts).
 */
export const mSrEnGB = {
    'sr.phone.homeTile': 'Building fire list: {building}',
    'sr.phone.homeTileActive': 'Evacuation in progress: {building}',
    'sr.phone.homeTileOpen': 'Open the building fire list',
    'sr.phone.enrolled': 'This phone is now set up as a fire marshal phone for {building}.',
    'sr.phone.enrolWorking': 'Setting up this phone as a fire marshal phone...',
    'sr.phone.subtitle': '{building}. Signed in as {name}.',
    'sr.phone.online': 'Online. List updated {time}.',
    'sr.phone.offline': 'No connection. Showing the list saved on this phone.',
    'sr.phone.pending': '{count} waiting to be sent. They are saved on this phone and will be sent when you are back online.',
    'sr.phone.pendingNone': 'Everything has been sent.',
    'sr.phone.notSent': '{count} could not be sent and were refused by the server. Tell the building administrator.',
    'sr.phone.notSentSeen': 'I have seen this',
    'sr.phone.onSiteTitle': 'On site now',
    'sr.phone.onSiteCount': '{count} on site',
    'sr.phone.listOff': 'The on-site list is switched off for this building. It will show during an evacuation.',
    'sr.phone.refresh': 'Update the list',
    'sr.phone.noOne': 'Nobody is on the list.',
    'sr.phone.signedInAt': 'Signed in {time}',
    'sr.phone.evac.title': 'Evacuation: {kind}',
    'sr.phone.evac.kind.real': 'real',
    'sr.phone.evac.kind.drill': 'drill',
    'sr.phone.evac.started': 'Started {time}, {label}',
    'sr.phone.evac.localOnly': 'Started on this phone. It will be sent to the building when you have a signal.',
    'sr.phone.evac.totals': '{unaccounted} to find, {safe} safe, {missing} missing, {offSite} off site',
    'sr.phone.evac.toFind': '{count} to find',
    'sr.phone.evac.groupCompany': 'By company',
    'sr.phone.evac.groupMuster': 'By muster point',
    'sr.phone.evac.noMuster': 'No muster point yet',
    'sr.phone.evac.musterLabel': 'Muster point you are at (optional)',
    'sr.phone.evac.markSafe': 'Safe',
    'sr.phone.evac.markMissing': 'Missing',
    'sr.phone.evac.markUndo': 'Undo',
    'sr.phone.evac.status.unaccounted': 'To find',
    'sr.phone.evac.status.safe': 'Safe',
    'sr.phone.evac.status.missing': 'Missing',
    'sr.phone.evac.status.off_site': 'Off site',
    'sr.phone.evac.rowLabel': '{name}, {company}, {status}',
    'sr.phone.evac.noList': 'There is no list on this phone yet, so nobody can be shown. Connect to the internet to get the list.',
    'sr.phone.evac.startDrill': 'Start a drill',
    'sr.phone.evac.startReal': 'Start a real evacuation',
    'sr.phone.evac.confirmDrill': 'Start a drill for the whole building?',
    'sr.phone.evac.confirmReal': 'Start a REAL evacuation for the whole building?',
    'sr.phone.evac.confirmYes': 'Start',
    'sr.phone.evac.cancel': 'Cancel',
    'sr.phone.evac.end': 'End the evacuation',
    'sr.phone.evac.confirmEnd': 'End this evacuation for the whole building?',
    'sr.phone.evac.confirmEndYes': 'End it',
    'sr.phone.evac.endNeedsOnline': 'Ending needs a connection.',
    'sr.phone.endNeedsSync': 'This evacuation has not been sent to the building yet. Connect to the internet and wait for the marks to be sent, then end it.',
    'sr.phone.lock.setTitle': 'Protect the list with a PIN',
    'sr.phone.lock.setIntro': 'The building list shows names, so this phone needs a PIN or fingerprint lock before it can be shown. Choose a PIN of 4 to 6 digits.',
    'sr.phone.lock.pin': 'New PIN',
    'sr.phone.lock.pinAgain': 'Repeat the PIN',
    'sr.phone.lock.pinMismatch': 'The two PINs do not match.',
    'sr.phone.lock.pinShort': 'The PIN must be 4 to 6 digits.',
    'sr.phone.lock.save': 'Save the PIN',
    'sr.phone.lock.title': 'Unlock the building list',
    'sr.phone.lock.leave': 'Forgot the PIN? Sign this phone out of the building',
    'sr.phone.leave': 'Sign this phone out of the building',
    'sr.phone.leaveConfirm': 'Sign this phone out of {building}? The list on this phone will be deleted.',
    'sr.phone.leaveYes': 'Sign out',
    'sr.phone.notEnrolled': 'This phone is not set up as a fire marshal phone. Open the invitation link from your email, or scan its QR code.',
    'sr.phone.removed': 'This phone has been signed out of the building. The list on it has been deleted.',
};
//# sourceMappingURL=m-sr.js.map